import { i as n, x as h, s as m } from "../../lit-element-6iugfgmM.js";
import { e as p } from "../../custom-element-wk-AooBb.js";
import { n as b } from "../../property-BWlAHqg_.js";
import "../../query-assigned-elements-B8U94KLQ.js";
import d from "../../events/ImagesToggleEvent.js";
import "../../sp-checkbox-Bk_eAZdk.js";
import { Analytics as u } from "../../lib/Analytics.js";
import { Localize as k } from "../../lib/I18N.js";
const x = { "images-toggle.label": "Images" }, g = n`.blue-checkbox{--spectrum-checkbox-m-box-border-color: var(--spectrum-global-color-static-blue-500);--spectrum-checkbox-m-box-border-color-down: var(--spectrum-global-color-static-blue-500);--spectrum-checkbox-m-box-border-color-hover: var(--spectrum-global-color-static-blue-500);--spectrum-checkbox-m-box-border-color-selected: var(--spectrum-global-color-static-blue-500);--spectrum-checkbox-m-box-border-color-selected-down: var(--spectrum-global-color-static-blue-500);--spectrum-checkbox-m-box-border-color-selected-hover: var(--spectrum-global-color-static-blue-500)}`;
var v = Object.defineProperty, f = Object.getOwnPropertyDescriptor, i = (e, o, s, r) => {
  for (var l, c = r > 1 ? void 0 : r ? f(o, s) : o, a = e.length - 1; a >= 0; a--) (l = e[a]) && (c = (r ? l(o, s, c) : l(c)) || c);
  return r && c && v(o, s, c), c;
};
let t = class extends u(k(m, x)) {
  constructor() {
    super(...arguments), this.checkboxClass = "", this.checked = !1;
  }
  static get styles() {
    return g;
  }
  connectedCallback() {
    this._initEventListeners(), super.connectedCallback();
  }
  render() {
    return h`<sp-checkbox class="${this.checkboxClass}" .checked="${this.checked}" @click="${(e) => this._handleClick(e)}">${this.t("images-toggle.label")}</sp-checkbox>`;
  }
  _handleClick(e) {
    this.sendAnalyticsEvent("images-toggle-checkbox-click", { isChecked: !e.target.checked }), this.dispatchEvent(new d(!e.target.checked));
  }
  _initEventListeners() {
    window.addEventListener("sample-text.blur", () => {
      this.checkboxClass = "";
    }), window.addEventListener("sample-text.focus", () => {
      this.checkboxClass = "blue-checkbox";
    });
  }
};
i([b({ type: String })], t.prototype, "checkboxClass", 2), i([b({ type: Boolean })], t.prototype, "checked", 2), t = i([p("af-images-toggle")], t);
const j = t;
export {
  j as default
};
//# sourceMappingURL=ImagesToggle.js.map
